export default "__VITE_ASSET__9f01029a__"